import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgModule } from "@angular/core";
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from "./app.component";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { TokenInterceptor } from './services/interceptor/token.interceptor';
import { RouterModule } from "@angular/router";
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { CommonModule } from '@angular/common';

import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { ToastrModule } from "ngx-toastr";
import { TagInputModule } from "ngx-chips";
import { CollapseModule } from 'ngx-bootstrap/collapse';

import { BrowserModule } from '@angular/platform-browser';
import { ComponentsModule } from "./components/components.module";
import { NgbActiveModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';

import { OrderPublicViewComponent } from './order-public-view/order-public-view.component';
import { InterceptorService } from "./services/loader/interceptor.service";
import { QRPaymentComponent } from "./qr-ayment/qr-payment.component";
import { CreateUpsellOrderComponent } from './create-upsell-order/create-upsell-order.component';
import { UpsellOrderComponent } from "./upsell-order/upsell-order.component";
import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { publicComponent } from "./layouts/public/public.component";
import { secureComponent } from "./layouts/secure/secure.component";
import { authComponent } from "./layouts/auth/auth.component";
import { ForgotpasswordComponent } from './pages/forgotpassword/forgotpassword.component';
import { ResetpasswordComponent } from './pages/resetpassword/resetpassword.component';
import { OrderPublicViewSubmitComponent } from './order-public-view-submit/order-public-view-submit.component';
import { OrderPublicViewDeleteComponent } from './order-public-view-delete/order-public-view-delete.component';
import { IndependentUpsellOrderComponent } from "./independent-upsell-order/independent-upsell-order.component";
import { FeedbackComponent } from './pages/feedback/feedback.component';
import { DateRangeComponent } from './pages/date-range/date-range.component';
import { PhleboFeedbackComponent } from './pages/phlebo-feedback/phlebo-feedback.component';
import { FullCalendarModule } from '@fullcalendar/angular';
import { SharedService } from './services/shared/shared.service';
import { PhleboRouteComponent } from './src/app/pages/orders/phlebo-route/phlebo-route.component';
import { PostOrderComponent } from "./post-order/post-order.component";
import { AddUserComponent } from './add-user/add-user.component';
import { AddEditDiscountComponent } from "./add-edit-discount/add-edit-discount.component";
import { AddPatientComponent } from "./add-patient/add-patient.component";
import { AddAddressComponent } from "./add-address/add-address.component";
import { AddEnduserComponent } from "./add-enduser/add-enduser.component";
// import { PhoneFormatPipe } from './pipe/phoneFormat/phone-format.pipe';
// import { SignupComponent } from './pages/signup/signup.component';
// import { FinanceReportComponent } from './pages/finance-report';
// import { FinanceReportListComponent } from './pages/finance-report/finance-report-list/finance-report-list.component';
// import { RatingModule } from "primeng/rating";
import { AngularFireModule } from '@angular/fire';
import { AngularFireDatabaseModule } from '@angular/fire/database';
import { environment } from '../environments/environment';

@NgModule({
    declarations: [
        AppComponent,
        secureComponent,
        publicComponent,
        authComponent,
        QRPaymentComponent,
        OrderPublicViewComponent,
        CreateUpsellOrderComponent,
        UpsellOrderComponent,
        ForgotpasswordComponent,
        ResetpasswordComponent,
        OrderPublicViewSubmitComponent,
        OrderPublicViewDeleteComponent,
        IndependentUpsellOrderComponent,
        FeedbackComponent,
        DateRangeComponent,
        PhleboFeedbackComponent,
        PhleboRouteComponent,
        PostOrderComponent,
        AddUserComponent,
        AddEditDiscountComponent,
        AddPatientComponent,
        AddAddressComponent,
        AddEnduserComponent,
    ],
    imports: [
        BrowserAnimationsModule,
        BrowserModule,
        AppRoutingModule,
        ComponentsModule,
        NgbModule,
        RouterModule,
        HttpClientModule,
        ReactiveFormsModule,
        FormsModule,
        CommonModule,
        ToastrModule.forRoot(),
        BsDropdownModule.forRoot(),
        CollapseModule.forRoot(),
        BsDatepickerModule.forRoot(),
        TagInputModule,
        NgMultiSelectDropDownModule.forRoot(),
        FullCalendarModule,
        AngularFireModule.initializeApp(environment.firebaseConfig),
        AngularFireDatabaseModule,
        BsDropdownModule.forRoot(),
        TagInputModule,
        BrowserModule,
        AppRoutingModule,
        FullCalendarModule,
        // PhoneFormatPipe,
        NgMultiSelectDropDownModule.forRoot(),
        AngularFireModule.initializeApp(environment.firebaseConfig),  // ✅ THIS LINE IS CRITICAL
        AngularFireDatabaseModule 

    ],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true },
        DatePipe,
        NgbActiveModal,
        SharedService
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
